import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            为什么选择17黑料网
          </h2>
          <p className="text-sm text-foreground-500">用心打造最好的吃瓜体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group flex flex-col items-center text-center p-8 rounded-2xl bg-background-50 border border-secondary-200/40 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-800 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}